<!-- Search -->
<div (deferVizible)="loadContactsVisible$.next($event)">
  <ng-template #search>
    <div class="input-group">
      <input
        #input
        [attr.autofocus]="!isMobile"
        [ngModel]="q"
        (ngModelChange)="searchContacts($event)"
        type="text"
        class="form-control form-control-lg"
        placeholder="Введите имя или фамилию"
      />
      <div class="input-group-append">
        <button class="btn btn-lg btn-ico btn-secondary btn-minimal" type="submit">
          <i-feather name="search"></i-feather>
        </button>
      </div>
    </div>
  </ng-template>

  <div class="mb-6 position-relative">
    <ng-template [ngIf]="fixedSearch" [ngIfElse]="noFixed">
      <nz-affix *ngIf="showSearch" [nzOffsetTop]="offsetTop" [nzTarget]="scroll">
        <ng-template [ngTemplateOutlet]="search"></ng-template>
      </nz-affix>
    </ng-template>
    <ng-template #noFixed>
      <ng-template [ngTemplateOutlet]="search"></ng-template>
    </ng-template>
    <!--</nz-affix>-->
  </div>
  <!-- Search -->
  <!-- Chat Members -->
  <app-error-show
    (onReload)="loadContacts$.next('Reload')"
    [Service]="Service"
    [error]="isLoadError"
    *ngIf="isLoadError"
    class="h-100"
  ></app-error-show>
  <div *ngIf="!isLoaded && !isLoadError" class="text-center">
    <div class="mt-4 mb-3">
      <div class="loader-line"></div>
    </div>
  </div>
  <ul
    *ngIf="allMessengersService.arServicesAuthorized?.length > 1"
    id="menu-social"
    class="menu-social-horizontal navbar-round nav navbar-nav justify-content-center py-0 px-4 px-lg-5 mt-4"
    role="tablist"
  >
    <li
      [class.active]="item.type === loadedServiceType"
      *ngFor="let item of allMessengersService.arServicesAuthorized; let i = index"
      class="nav-item outline-none"
      (click)="contactsToggleService(item)"
    >
      <app-avatar
        [Service]="item"
        [id]="item.arProfile?.id"
        [type]="'private'"
        [avatar]="item.arProfile?.avatar"
        [avatarFileId]="item.arProfile?.avatar_file_id"
        [avatarFileUniqueId]="item.arProfile?.avatar_file_unique_id"
        [serviceType]="item.type"
        class="d-inline-block avatar avatar-sm mx-2"
      >
      </app-avatar>
      <!--<a class="nav-link position-relative p-0 pointer mx-2" title="{{ item.name }}">
        <i-feather class="logo-small" [name]="item.type | fixType"></i-feather>
      </a>-->
    </li>
  </ul>
  <nav *ngIf="isLoaded" class="list-group list-group-flush mb-n6 mt-5">

    <!-- Friend -->
    <ng-container *ngFor="let client of arResult; trackBy: trackByFn; let i = index">
      <ng-template [ngIf]="i <= showCount">
        <div *ngIf="client.show_title" class="mb-6">
          <small class="text-uppercase">{{ client.first_character }}</small>
        </div>
        <div (mousemove)="allService.effectMouseMove($event)" class="effectMouse card mb-5">
          <div class="card-body p-3 pointer">
            <div class="media">
              <app-avatar
                [Service]="Service"
                [id]="client.id"
                [class.avatar-online]="client?.online"
                [type]="'private'"
                [avatar]="client.avatar"
                [avatarFileId]="client.avatar_file_id"
                [avatarFileUniqueId]="client.avatar_file_unique_id"
                [serviceType]="client.service_type"
                class="avatar mr-4 mr-xl-6"
              ></app-avatar>
              <div class="media-body overflow-hidden align-self-center mr-2 mr-xl-6">
                <h6 class="text-truncate text-nowrap mr-auto mb-1">
                  <ng-template [ngIf]="client?.name?.first" [ngIfElse]="elseName">
                  <span
                    [innerHTML]="client?.name?.first + ' ' + client?.name?.last | replaceEmojis: 'facebook':20:64"
                  ></span>
                  </ng-template>
                  <ng-template #elseName>
                  <span
                    [innerHTML]="
                      client?.title || client?.username || client?.phone_number || 'Удаленный аккаунт'
                        | replaceEmojis: 'facebook':20:64
                    "
                  ></span>
                  </ng-template>
                  <div *ngIf="!client?.last_seen?.time && client?.username" class="text-muted small">
                    @{{client?.username}}</div>
                </h6>
                <div class="small text-muted text-truncate rlt text-nowrap">
                  <app-text-user-online [last_seen]="client.last_seen" [online]="client.online"></app-text-user-online>
                </div>
              </div>
              <div [class.hidden]="!isCheckbox" class="align-self-center ml-auto">
                <div class="custom-control custom-checkbox">
                  <input
                    (change)="toggleUser($event, client)"
                    [checked]="client.checked"
                    class="custom-control-input"
                    id="id-user-{{ formId }}-{{ i }}"
                    type="checkbox"
                  />
                  <label class="custom-control-label" for="id-user-{{ formId }}-{{ i }}"></label>
                </div>
              </div>
            </div>
          </div>
          <!-- Label -->
          <label class="stretched-label pointer" for="id-user-{{ formId }}-{{ i }}"></label>
        </div>
      </ng-template>
    </ng-container>
    <!--<div (deferVizible)="lazyLoad($event)"></div>-->
  </nav>
  <!-- Tabs -->
</div>
